import SuperScriptStr from 'components/atoms/String/SuperScriptStr';
import NftData from 'interfaces/NftData.interface';
import moment from 'moment';
import { FC, useEffect, useRef, useState } from 'react';
import { calculateTimeDifference } from 'utils/time-difference';

interface ITimer {
  nft: NftData;
}

const Timer: FC<ITimer> = ({ nft }) => {
  const timerRef = useRef<ReturnType<typeof setInterval>>();
  const [timeLeft, setTimeLeft] = useState<string>('');

  useEffect(() => {
    if (nft.endsAt) {
      if (calculateTimeDifference(nft.endsAt) > 0)
        timerRef.current = setInterval(() => {
          const diffTime = calculateTimeDifference(nft.endsAt as Date);
          const duration = moment.duration(diffTime);
          const hours = parseInt(duration.asHours() as any);
          const minutes = parseInt((duration.asMinutes() % 60) as any);
          const seconds = parseInt((duration.asSeconds() % 60) as any);
          setTimeLeft(hours + '//' + minutes + '/-/' + seconds);
        }, 1000);
    }
    //eslint-disable-next-line
  }, [nft]);

  useEffect(() => {
    return () => {
      clearInterval(timerRef.current);
    };
  }, []);
  return (
    <>
      <SuperScriptStr
        text={timeLeft.split('//')[0]}
        sup={'hr'}
        style={{
          color: '#e5e5e5',
          fontSize: '1.8rem',
          marginRight: '5px',
        }}
      />
      <SuperScriptStr
        text={timeLeft.split('//')[1]?.split('/-/')[0]}
        sup={'mn'}
        style={{
          color: '#e5e5e5',
          fontSize: '1.8rem',
          marginRight: '5px',
        }}
      />
      <SuperScriptStr
        text={timeLeft.split('//')[1]?.split('/-/')[1]}
        sup={'sec'}
        style={{
          color: '#e5e5e5',
          fontSize: '1.8rem',
          marginRight: '5px',
        }}
      />
    </>
  );
};

export default Timer;
